import React, { FC } from 'react'
import styles from './TableFilters.module.css'
import CustomButton from '../UI/CustomButton/CustomButton'
import glassIcon from '../../assets/icons/glass.svg'
import { FiltersTitlesForTable } from '../../types'
import {
  createStatusForCompanyFilters,
  createStatusForRegistrationRequestFilters,
} from '../../utils/createRoleForRegister'
import { useMediaQuery } from 'react-responsive'

export type TableFiltersPropsType = FiltersTitlesForTable & {
  isPlatforms?: boolean
  isCompany?: boolean
  handleFirstButtonClick: (title: string) => void
  handleSecondButtonClick: (title: string) => void
  handleThirdButtonClick: (title: string) => void
  handleFourthButtonClick: (title: string) => void
  debouncedStatus?: string
  search: string
  setSearch: (searchItem: string) => void
  customButton?: JSX.Element
  filtersMobile?: JSX.Element
}

const TableFilters: FC<TableFiltersPropsType> = ({
  isPlatforms,
  isCompany,
  filtersMobile,
  firstBtnTitle,
  secondBtnTitle,
  thirdBtnTitle,
  fourthBtnTitle,
  handleFirstButtonClick,
  handleSecondButtonClick,
  handleThirdButtonClick,
  handleFourthButtonClick,
  debouncedStatus,
  search,
  setSearch,
  customButton,
}) => {
  const handleSearch = (e: any) => {
    setSearch(e.target.value)
  }
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
  return (
    <div className={styles.tableFilters}>
      {!isPlatforms ? (
        <>
          <div className={styles.tableControlBlock}>
            {isCompany ? (
              <div className={styles.tableBtns}>
                <div className={styles.btnWrapper}>
                  <CustomButton
                    onClick={() => handleFirstButtonClick(firstBtnTitle)}
                    title={firstBtnTitle}
                    className={
                      createStatusForCompanyFilters(debouncedStatus) === firstBtnTitle
                        ? `${styles.filtersAllBtn} ${styles.active}`
                        : styles.filtersAllBtn
                    }
                  />
                  <CustomButton
                    onClick={() => handleSecondButtonClick(secondBtnTitle)}
                    title={secondBtnTitle}
                    className={
                      createStatusForCompanyFilters(debouncedStatus) === secondBtnTitle
                        ? `${styles.filtersBtn} ${styles.active}`
                        : styles.filtersBtn
                    }
                  />
                  <CustomButton
                    onClick={() => handleThirdButtonClick(thirdBtnTitle)}
                    title={thirdBtnTitle}
                    className={
                      createStatusForCompanyFilters(debouncedStatus) === thirdBtnTitle
                        ? `${styles.filtersBtn} ${styles.active}`
                        : styles.filtersBtn
                    }
                  />
                  {fourthBtnTitle && (
                    <CustomButton
                      onClick={() => handleFourthButtonClick(fourthBtnTitle)}
                      title={fourthBtnTitle}
                      className={
                        createStatusForCompanyFilters(debouncedStatus) === fourthBtnTitle
                          ? `${styles.filtersBtn} ${styles.active}`
                          : styles.filtersBtn
                      }
                    />
                  )}
                </div>
                {filtersMobile}
              </div>
            ) : (
              <div className={styles.tableBtns}>
                <CustomButton
                  onClick={() => handleFirstButtonClick(firstBtnTitle)}
                  title={firstBtnTitle}
                  className={
                    createStatusForRegistrationRequestFilters(debouncedStatus) === firstBtnTitle
                      ? `${styles.filtersAllBtn} ${styles.active}`
                      : styles.filtersAllBtn
                  }
                />
                <CustomButton
                  onClick={() => handleSecondButtonClick(secondBtnTitle)}
                  title={secondBtnTitle}
                  className={
                    createStatusForRegistrationRequestFilters(debouncedStatus) === secondBtnTitle
                      ? `${styles.filtersBtn} ${styles.active}`
                      : styles.filtersBtn
                  }
                />
                <CustomButton
                  onClick={() => handleThirdButtonClick(thirdBtnTitle)}
                  title={thirdBtnTitle}
                  className={
                    createStatusForRegistrationRequestFilters(debouncedStatus) === thirdBtnTitle
                      ? `${styles.filtersBtn} ${styles.active}`
                      : styles.filtersBtn
                  }
                />
                {fourthBtnTitle && (
                  <CustomButton
                    onClick={() => handleFourthButtonClick(fourthBtnTitle)}
                    title={fourthBtnTitle}
                    className={
                      createStatusForRegistrationRequestFilters(debouncedStatus) === fourthBtnTitle
                        ? `${styles.filtersBtn} ${styles.active}`
                        : styles.filtersBtn
                    }
                  />
                )}
              </div>
            )}
          </div>
          <form
            className={styles.tableSearch}
            autoComplete={'off'}
            onSubmit={(e) => e.preventDefault()}
          >
            <div className={styles.glassBlock}>
              <img className={styles.glassIcon} src={glassIcon} alt='glass' />
              <input
                name='name'
                type='text'
                autoComplete='off'
                className={styles.input}
                placeholder='Поиск...'
                value={search}
                onChange={handleSearch}
              />
            </div>
            {customButton}
          </form>
        </>
      ) : (
        <>
          <form
            className={styles.tableSearch}
            autoComplete={'off'}
            onSubmit={(e) => e.preventDefault()}
          >
            <div className={styles.glassBlock}>
              <img className={styles.glassIcon} src={glassIcon} alt='glass' />
              <input
                name='name'
                type='text'
                autoComplete='off'
                className={styles.input}
                placeholder='Поиск...'
                value={search}
                onChange={handleSearch}
              />
            </div>
            {customButton}
          </form>
        </>
      )}
    </div>
  )
}

export default TableFilters
